import React, { useState } from 'react'
import { Box, Button, Checkbox } from '@mui/material'
import RequestDialog from '../dialogs/RequestDialog'
import { useLatestMasterForTreeId } from 'shared/api/tree'

export function CurriculaButton({
  onSelect,
  treeId,
  productId,
  activatePopUp,
  popUpText,
  isSelected,
}: {
  onSelect: (selection: {
    treeId: string
    productId: number
    treeVersion: string
    masterTitle: string
  }) => void
  treeId: string
  productId: number
  activatePopUp?: boolean
  popUpText?: string
  isSelected?: boolean
}) {
  const [open, setOpen] = useState(false)
  const latestMaster = useLatestMasterForTreeId(treeId)

  const handleOnSelect = async () => {
    if (!latestMaster) return
    onSelect({
      treeId,
      productId,
      treeVersion: latestMaster.version,
      masterTitle: latestMaster.title,
    })
  }
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  if (!latestMaster) return null

  return (
    <>
      <Button
        key={treeId}
        onClick={activatePopUp ? handleClickOpen : handleOnSelect}
        sx={{
          backgroundColor: isSelected ? 'rgba(56, 180, 252, 0.08)' : undefined,
          justifyContent: 'flex-start',
        }}
      >
        <Checkbox
          checked={!!isSelected}
          size="small"
          sx={{ padding: '2px', marginRight: '4px' }}
          tabIndex={-1}
          disableRipple
        />
        <Box textAlign={'start'} width={'85%'}>
          {`${latestMaster.title} ${latestMaster.name} -- ${latestMaster.createdAt}`}
        </Box>
      </Button>
      <RequestDialog
        open={open}
        title={popUpText || ''}
        content={[{ key: 'Curriculum title', value: latestMaster.title }]}
        submitRequest={handleOnSelect}
        onClose={handleClose}
      />
    </>
  )
}
